import type { Tile } from "@/api/queries";

/** Tiles in the order their owner lays them out. */
export function tileSections(tiles: Tile[]) {
  return [...tiles].sort((left, right) => left.sort_order - right.sort_order);
}

export function hasCharts(artifacts: Array<{ chart?: unknown }>) {
  return artifacts.some((artifact) => Boolean(artifact.chart));
}

/** Maps draw after their boundaries load, so the print hook waits for them. */
export function mapCount(artifacts: Array<{ family?: string | null }>) {
  return artifacts.filter((artifact) => artifact.family === "geographic").length;
}
